export default{
  "Mute Video": "비디오 소리 제거",
  "HitPaw Online Mute Video": "HitPaw 온라인 비디오 소리 제거",
  "Fast and easy to remove sound from your video online": "온라인으로 비디오에서 빠르고 쉽게 소리 제거할 수 있습니다.",
  "Muting": "소리 제거중입니다.",
  "Mute Failed": "소리 제거에 실패했습니다.",
  "Mute New": "새 파일  소리 제거"
};